module.exports = __webpack_public_path__ + "static/media/jiaoyu.23a292ff.png";